import { currencyList } from '../../../../utils/currency'

export const currenciesOptions: string[] = currencyList
